/*
 *
 * LeadsPage reducer
 *
 */

import {
  DOWNLOAD_LEADS_REQUEST,
  DOWNLOAD_LEADS_SUCCESS,
  DOWNLOAD_LEADS_FAIL,
  FETCH_LEADS_REQUEST,
  FETCH_LEADS_SUCCESS,
  FETCH_LEADS_FAIL,
} from './constants';
import { toNumber } from 'utils/helpers'

const initialState = {
  fetching: false,
  downloading: false,
  allLeads: {},
  paging: {},
  errors: null,
};

function leadsPageReducer(state = initialState, action) {
  switch (action.type) {
    case DOWNLOAD_LEADS_REQUEST:
      return {
        ...state,
        downloading: true,
      };
    case DOWNLOAD_LEADS_SUCCESS:
      alert('CSV processing started. Check your email in a few minutes.');
      return {
        ...state,
        downloading: false,
      };
    case DOWNLOAD_LEADS_FAIL:
      return {
        ...state,
        downloading: false,
        errors: action.errors,
      };
    case FETCH_LEADS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case FETCH_LEADS_SUCCESS:
      return {
        ...state,
        allLeads: action.data,
        paging: {
          currentPage: toNumber(action.current_page),
          rowsPerPage: toNumber(action.rows_per_page),
          pageCount: toNumber(action.page_count),
        },
        fetching: false,
      };
    case FETCH_LEADS_FAIL:
      return {
        ...state,
        fetching: false,
        errors: action.errors
      };
    default:
      return state;
  }
}

export default leadsPageReducer;



// WEBPACK FOOTER //
// ./src/containers/LeadsPage/reducer.js